export default __webpack_public_path__ + "static/media/getboatcom_for_boat_owners.cfb36152.webp";